import React from 'react';
import './card.scss';
export var CardFooter = function (_a) {
    var children = _a.children, childClasses = _a.childClasses;
    return React.createElement("div", { className: "c-card__footer ".concat(childClasses !== null && childClasses !== void 0 ? childClasses : '') }, children);
};
